<template>
  <div class="header-menu-win-wire" :class="{ 'header-menu-win-wire--red': shouldNotify }" @click="handleClick">
    <IconWinWire class="header-menu-win-wire__icon" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'HeaderMenuWinWire',
  components: { IconWinWire: () => import('@/components/Icon/WinWire.vue') },
  data() {
    return {
      previousDealsSummary: {
        totalAmount: 0,
        totalCount: 0,
      },
    };
  },
  computed: {
    ...mapState('deals', ['dealsSummary']),
    shouldNotify() {
      return (
        this.dealsSummary.totalCount > this.previousDealsSummary.totalCount &&
        this.dealsSummary.totalAmount > this.previousDealsSummary.totalAmount
      );
    },
  },
  mounted() {
    const savedDealSummary = localStorage.getItem('deals_summary-mobile');
    this.previousDealsSummary = savedDealSummary ? JSON.parse(savedDealSummary) : this.previousDealsSummary;
  },
  methods: {
    updateDealSummary() {
      this.previousDealsSummary = this.dealsSummary;

      localStorage.setItem('deals_summary-mobile', JSON.stringify(this.dealsSummary));
    },
    handleClick() {
      this.updateDealSummary();
      this.$modal.showWithRoute({ custom: 'win-wire' });
    },
  },
};
</script>

<style scoped lang="scss">
.header-menu-win-wire {
  @include flex-center;

  margin-left: 18px;
  cursor: pointer;
  position: relative;
  top: -1px;

  &--red {
    &::after {
      content: '';
      position: absolute;
      right: 1px;
      top: 1px;
      width: 6px;
      height: 6px;
      background-color: var(--red-50);
      border-radius: 50%;
    }
  }

  &__icon {
    color: var(--theme-color-text);
  }
}
</style>
